import styled from "styled-components";

import {
  ButtonSecondary,
} from "components/Buttons";

export const Container = styled.div`
  background-color: #fff;
  width: 100%;
  max-width: 600px; 
  height: ${({empty}) => empty ? '50%' : 'fit-content'};
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%);
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const ContentContainer = styled.div`
`;

export const SubTitle = styled.h4`
  font-size: 12px;
  font-weight: 400;
  margin: 8px 0;
  text-align: center;
`;

export const SubHeader = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: center;
  background: #fff;
  margin: 0;
  padding: 8px;
`;

export const Button = styled(ButtonSecondary)`
  color: #fff;
  margin: 16px 0;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row; 
  padding: 16px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  box-shadow: 0px 2px 3px 0px rgba(214, 214, 214, 1);
`;